import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilService } from '../../../../core/services/util/util.service';

@Component({
  selector: 'app-update-product-set-check-list',
  templateUrl: './update-product-set-check-list.component.html',
  styleUrl: './update-product-set-check-list.component.css'
})
export class UpdateProductSetCheckListComponent implements OnInit {

  checkList: Array<{ channel: string, name: string, checked: boolean, user_id: string, date: number }> = []
  users: Array<{ user_id: string, name: string }> = []
  setSku: string = ''
  setName: string = ''

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private util: UtilService,
    private ref: MatDialogRef<UpdateProductSetCheckListComponent>
  ) {
  }


  ngOnInit(): void {
    this.checkList = this.data.check_list;
    this.users = this.data.users;
    this.setSku = this.data.set_sku || '';
    this.setName = this.data.name || '';
  }

  close() {
    this.ref.close({ confirm: false });
  }

  confirm() {
    this.ref.close({ confirm: true, data: this.checkList });
  }

  get checkedCount(): number {
    return this.checkList.filter(item => item.checked).length;
  }

  isAllChecked(): boolean {
    return this.checkList.length > 0 && this.checkList.every(item => item.checked);
  }

  isIndeterminate(): boolean {
    const checkedCount = this.checkList.filter(item => item.checked).length;
    return checkedCount > 0 && checkedCount < this.checkList.length;
  }

  toggleAll(checked: boolean) {
    this.checkList.forEach(item => item.checked = checked);
  }

  getUserName(userId: string) {
    return this.users.find(item => item.user_id === userId)?.name
  }

  getDateString(date: number) {
    return this.util.dayjs(date).format('DD/MM/YYYY, HH:mm')
  }
}
